import { Modal, formatCurrency } from "@scandotcom/react";
import React from "react";
import { IconRapid } from "../Icons";
import { isNil } from "../utils";

interface Props extends React.ComponentProps<typeof Modal> {
  nextDaySurcharge: number | null;
}

export function NextDayModal({ onClose, nextDaySurcharge, ...props }: Props) {
  return (
    <Modal
      {...props}
      onClose={onClose}
      className="w-screen space-y-4 sm:max-w-sm"
      transition="up"
    >
      <Modal.Header onClose={onClose} type="close">
        <div className="flex items-center gap-x-2">
          <IconRapid className="h-8 w-8" />
          <h2 className="sm:mr-auto">Next Day appointments</h2>
        </div>
      </Modal.Header>

      <p>
        Get an appointment within the next 24 hours, if you complete your
        booking before 2pm today.
        {!isNil(nextDaySurcharge) ? (
          <>
            {" "}
            This costs an additional {formatCurrency(nextDaySurcharge / 100)}.
          </>
        ) : null}
      </p>

      <p>
        You'll need to be available for a pre-scan consultation call with a
        clinician{" "}
        <span className="font-semibold underline">
          within the next 2 working hours
        </span>{" "}
        (between 9am and 5pm, Monday to Friday).
      </p>

      <p>
        Please note that if our clinical team are unable to reach you, they
        won't be able to process your referral and your scan will be moved to
        the next working day.
      </p>
      <button type="button" className="button button-white" onClick={onClose}>
        Got it
      </button>
    </Modal>
  );
}
